import { env } from "config";
import React from "react";
import * as S from "./ReportChannel.style";

const ReportChannel = (props) => {
  return (
    <S.ReportChannelSection
      className="make-section"
      data-section="Canal de ética section"
      $background={props.background}
    >
      <S.ReportChannelSectionContent className="container">
        <S.InfoContainer>
          <S.MainTitle
            variant="headline-02"
            color="primary"
            id="canal-de-etica"
          >
            Canal de Ética
          </S.MainTitle>

          {!props?.hiddenMainDescription && (
            <S.MainDescription variant="body02-md">
              Você pode registrar um relato de práticas antiéticas ou ilegais.
              Os relatos serão analisados e tratados de forma sigilosa.
            </S.MainDescription>
          )}
        </S.InfoContainer>
        <S.InfoContainer2>
          <S.StyledAccordion>
            <S.StyledAccordionItem
              title="É seguro?"
              className="make-click"
              data-label="é seguro accordion"
            >
              Totalmente. Quando você registra um relato usando o canal de
              ética, seus dados e informações estão sempre protegidos. Mesmo que
              você se identifique, garantimos a confidencialidade.
            </S.StyledAccordionItem>
            <S.StyledAccordionItem
              title="Quando registrar um relato?"
              className="make-click"
              data-label="quando registrar um relato accordion"
            >
              Se você vivenciou algum comportamento antiético como assédio,
              fraude, corrupção, lavagem de dinheiro e outros fatos que violam a
              ética, este é o lugar pra você falar com a gente com segurança.
            </S.StyledAccordionItem>
            <S.StyledAccordionItem
              title="O que acontece com o meu relato?"
              className="make-click"
              data-label="o que acontece accordion"
            >
              O relato será recebido e analisado de forma anônima. Ele será
              investigado e você pode acompanhar de perto seu desfecho.
            </S.StyledAccordionItem>
            <S.StyledAccordionItem
              title="Como posso ter acesso ao Código de Ética e Conduta para os empregados?"
              className="make-click"
              data-label="Código de Ética accordion"
            >
              Para ter acesso ao Código de Ética e Conduta destinado aos
              empregados da CNP Seguros Holding Brasil, basta{" "}
              <a
                href={`${env.HOST_STATIC_CDN}/AreaAberta/Relatorios/Conformidade/CNP_21_C%C3%B3digo_de_%C3%89tica.pdf?_ga=2.62433455.2021650386.1673978070-2053953881.1659386037`}
                target="_blank"
                rel="noreferrer"
              >
                <strong>clicar aqui</strong>
              </a>{" "}
              e baixar o documento completo.
              <br />
              <br />
              Nele, você tem acesso as principais diretrizes e regras mínimas
              que devem ser cumpridas por todos os colaboradores da empresa.
            </S.StyledAccordionItem>
            <S.StyledAccordionItem
              title="Como posso ter acesso ao Código de Ética e Conduta para prestadores de serviços e parceiros de negócio?"
              className="make-click"
              data-label="Conduta para prestadores de serviços accordion"
            >
              Para ter acesso ao Código de Ética e Conduta destinado aos
              prestadores de serviços e parceiros de negócio da CNP Seguros
              Holding Brasil, basta{" "}
              <a
                href={`${env.HOST_STATIC_CDN}/AreaAberta/Relatorios/Conformidade/CNP_21_C%C3%B3digo_de_%C3%89tica_Fornecedor.pdf?_ga=2.62433455.2021650386.1673978070-2053953881.1659386037`}
                target="_blank"
                rel="noreferrer"
              >
                <strong>clicar aqui</strong>
              </a>{" "}
              e baixar o documento completo.
              <br />
              <br />
              Nele, você terá acesso aos normativos internos e a legislação
              vigente que são norteadores da atuação dos parceiros e prestadores
              de serviço para com a Companhia.
            </S.StyledAccordionItem>
          </S.StyledAccordion>

          <S.ActionDescription>
            Você pode relatar práticas antiéticas ou ilegais com garantia de
            sigilo. Lembre-se: toda denúncia de boa-fé é protegida contra
            retaliações, ou seja, você não poderá ser prejudicado por fazer a
            denúncia.
          </S.ActionDescription>

          <S.ActionButton
            variant="outlined"
            className="make-click"
            data-label="registrar um relato"
            role="link"
            onClick={() =>
              window.open(
                "https://www.contatoseguro.com.br/cnpholdingbrasil",
                "_blank",
              )
            }
          >
            Registrar um relato
          </S.ActionButton>
        </S.InfoContainer2>
      </S.ReportChannelSectionContent>
    </S.ReportChannelSection>
  );
};

export default ReportChannel;
